import DOMPurify from "dompurify";

export const splitStringyCurrency = (value = 0) => {
  const formattedValue = value.toString();
  let sepDollar = formattedValue.split(" ");
  if (sepDollar[0] === "$") {
    sepDollar = sepDollar[1];
  } else if (formattedValue.includes("$")) {
    sepDollar = formattedValue.replace("$", "");
  } else {
    sepDollar = sepDollar[0];
  }
  const sepSeperator = sepDollar.split(",");
  return Number(sepSeperator.join(""));
};

export const splitStringyNumber = (value) => {
  const sep = value?.toString().split(",");
  return Number(sep?.join(""));
};

export const splitStringyRate = (value) => {
  if (value) {
    const sepPer = value?.toString().split("%");
    const sep = sepPer.toString().split(",");
    return Number(sep.join("") / 100);
  }
  return null;
};

export const formatFixedDigits = (len, val) => {
  const valen = val?.toString().length;
  const ln = parseInt(len) - valen;
  let zeros = "";
  for (let i = 0; i < ln; i += 1) {
    zeros += "0";
  }
  return zeros + val + "";
};

export const taxIdFormat = (value) => {
  const str = value ? value.toString().trim() : "";
  return str.length > 2 ? str.substr(0, 2) + "-" + str.substr(2, 7) : str;
};

export const ssnFormat = (value) =>
  value
    ? value?.substr(0, 3) +
      "-" +
      value?.substr(3, 2) +
      "-" +
      value?.substr(5, 4)
    : "";
export const unauthorizedError = (error) => error?.err === 401;
export const sanitizeValue = (value) =>
  value ? DOMPurify.sanitize(value, { ALLOWED_TAGS: [] }).trim() : "";

export const phoneFormat = (value) =>
  "(" +
  value?.substr(0, 3) +
  ") " +
  value?.substr(3, 3) +
  "-" +
  value?.substr(6, 4);

export const displayNumberFormat = (value, dec = 2) => {
  const spl = value?.toLocaleString().split(".");
  if (spl) {
    let remDec = 0;
    if (spl[1]) {
      remDec = dec - spl[1].length;
    } else {
      spl[1] = "";
      remDec = dec;
    }
    let zeros = "";
    for (let i = 0; i < remDec; i += 1) {
      zeros += "0";
    }
    return spl[0] + "." + spl[1] + zeros;
  }
  return "0.00";
};

export const currencyStringFormat = (len, val) => {
  if (val === "0.00") {
    return "0.00".replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  const num = val?.toString().split(".");
  const valen = num[0]?.toString().length;
  const ln = parseInt(len) - valen;
  let zeros = "";
  for (let i = 0; i < ln; i += 1) {
    zeros += "0";
  }
  return (zeros + val + "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const formatCurrency = (value, decimalPlace = 2) => {
  const dollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: decimalPlace,
  });
  return value ? dollar.format(value) : dollar.format(0);
};

export const formatToPercentage = (value, decimalPlace = 2) => {
  const percentage = new Intl.NumberFormat("en-US", {
    style: "percent",
    minimumFractionDigits: decimalPlace,
    maximumFractionDigits: decimalPlace,
  });
  const formattedNumber = value ? parseFloat(value / 100) : "";
  return percentage.format(formattedNumber);
};

export const validateMaxValue = (value = 0, maxValue = 100) => {
  const parsedValue = parseFloat(value);
  if (parsedValue > maxValue) {
    return `Must be less than or equal to ${maxValue}.`;
  }
  return true;
};

export const validateNumberField = (value, errorMessage) => {
  if (value === null || value === undefined || value === "") {
    return errorMessage;
  }
  return true;
};

export const filterOptions = (data, valueKey, labelKey) =>
  data?.map((item) => ({
    value: item?.[valueKey],
    label: item?.[labelKey],
  })) || [];

export const getPagination = (pageSize, pageQuery) => {
  const pageNumber = pageQuery ? parseInt(pageQuery, 10) : 1;
  const offset = (pageNumber - 1) * pageSize;

  return { pageNumber, offset };
};

export const sortBy = (arr, key) => {
  const length = arr?.length;

  for (let i = 0; i < length - 1; i += 1) {
    let minIndex = i;

    for (let j = i + 1; j < length; j += 1) {
      if (arr[j][key] < arr[minIndex][key]) {
        minIndex = j;
      }
    }

    if (minIndex !== i) {
      [arr[i], arr[minIndex]] = [arr[minIndex], arr[i]];
    }
  }
  return arr;
};

export const getPluralSuffix = (count) => {
  return count > 1 ? "s" : "";
};

export const validateMaxLength = (value, maxLength) => {
  if (maxLength && value?.length > maxLength) {
    return true;
  }
  return false;
};

export const isValidNormalText = (value) => {
  const regex = /^[A-Za-z0-9'\s:.-]*$/;
  return regex.test(value);
};
